<template>
  <div class="person-info">
    <div class="title">{{ $t('PCUserInfo.index.647kboa03ks0') }}</div>
    <div class="item">
      <div class="item-left">{{ $t('PCUserInfo.index.647kboa06ys0') }}</div>
      <div class="item-right">
        <textarea
          v-model="form.userName"
          class="textarea"
          maxlength="65"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
        ></textarea>
      </div>
    </div>
    <div class="item">
      <div :class="['item-left', !form.pinCode ? 'gray-title' : '']">código de área</div>
      <div class="item-right" @click="select">
        <div class="item-right-text">
          <img
            :src="getFlagUrl"
            alt=""
            slot="prefix"
            style="width: 24px; height: 24px; margin-right: 10px"
          />
          {{ form.mobileAreaCode }}
        </div>
        <img src="../../../assets/image/settleAccount/arrow.png" alt="" />
      </div>
    </div>
    <div class="item">
      <div class="item-left">{{ $t('PCUserInfo.index.647kboa078s0') }}</div>
      <div class="item-right">
        <input
          v-model="form.mobile"
          type="text"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
          oninput="if(value.length>16)value=value.slice(0,16)"
        />
      </div>
    </div>

    <!-- 国家/城市选择 -->
    <van-popup v-model="showPicker" round position="bottom" class="popup">
      <div class="title">
        <div class="name">Código de área</div>
        <img
          @click="showPicker = false"
          src="../../../assets/image/settleAccount/close.png"
          alt=""
        />
      </div>
      <div class="list">
        <div
          v-for="(item, index) in mobileAreaCode"
          :key="index"
          :class="form.mobileAreaCode === item.areaCode ? 'select-item isSelect-item': 'select-item'"
          @click="chooseAreaCode(item)"
        >
          <span>
            <img :src="item.flagUrl" alt="" class="countryIcon" />
            {{ item.areaCode }} {{ item.countryName }}
          </span>
          <!-- <img
            class="select-img"
            v-if="form.mobileAreaCode === item.areaCode"
            src="../../../assets/image/settleAccount/choose.png"
            alt=""
          /> -->
          <img
            src="@/assets/PC/img/isSelect.png"
            class="select-img"
            v-if="form.mobileAreaCode === item.areaCode"
            alt=""
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getMobileAreaCode } from '@/services/api/home';
export default {
  name: 'PersonInfo',
  props: {
    info: Object
  },
  data() {
    return {
      form: {
        userName: '',
        mobile: '',
        mobileAreaCode: '+34'
      },
      showPicker: false,
      mobileAreaCode: []
    };
  },
  watch: {
    /**
     * 监听表单数据填写
     */
     form: {
      deep: true,
      immediate: true,
      handler: function (val) {
        let flag = Boolean(val && val.userName && val.mobile);
        let data = {
          flag,
          form: val
        };
        this.$emit('completePerson', data);
      }
    }
  },
  computed: {
    getFlagUrl() {
      // form.mobileAreaCode
      let url = '';
      this.mobileAreaCode.forEach(item => {
        if (item.areaCode == this.form.mobileAreaCode) {
          url = item.flagUrl;
        }
      });
      return url;
    }
  },
  mounted() {
    let textarea = document.querySelector('textarea');
    textarea.addEventListener('input', e => {
      textarea.style.height = '20px';
      textarea.style.height = e.target.scrollHeight + 'px';
    });
    this.getEnumList();
    const { userName, mobile, mobileAreaCode } = this.info;
    this.form = {
      userName,
      mobile,
      mobileAreaCode
    };
  
  },
  methods: {
    chooseAreaCode(item) {
      this.form.mobileAreaCode = item.areaCode;
      this.showPicker = false;
    },
    select() {
      this.showPicker = true;
    },
    getEnumList() {
      getMobileAreaCode().then(res => {
        this.mobileAreaCode = {};
        const { code, data } = res;
        if (code === '0000') {
          this.mobileAreaCode = data;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.person-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  margin-top: 88px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f4f5f7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5d5f65;
      margin-right: 32px;
    }
    .item-right {
      flex: 1;
      color: #333;
      display: flex;
      align-items: center;
      input {
        width: 100%;
        border: none;
        padding: 0;
        font-size: 28px;
        color: #333;
      }
      img {
        width: 10px;
        height: 20px;
        margin-left: 20px;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .error-tip {
        color: #f00;
        font-size: 24px;
        position: absolute;
        bottom: 0;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #ff9600;
          font-size: 24px;
          border-radius: 10px;
        }
        .gray-btn {
          opacity: 0.5;
        }
      }
    }
    .item-right-text {
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
  .item:last-child {
    border-bottom: none;
  }

  .textarea {
    flex: 1;
    width: 100%;
    height: 40px;
    border: none;
    padding: 0;
    font-size: 28px;
    color: #333;
  }
  .textarea::placeholder {
    color: #999;
    font-size: 28px;
  }

  .popup {
    .title {
      height: 96px;
      padding: 32px 40px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        color: #333;
        font-size: 32px;
        font-weight: 500;
      }
      img {
        width: 42px;
        height: 42px;
      }
    }
    .list {
      height: 796px;
      overflow: scroll;
      
      .select-item {
        height: 80px;
        padding: 20px 32px;
        box-sizing: border-box;
        // position: relative;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        span {
          font-size: 28px;
          color: #252629;
          // font-weight: 600;
          display: flex;
          align-items: center;
          .countryIcon {
            width: 48px;
            height: 48px;
            margin-right: 20px;
          }
        }
        .select-img {
          width: 40px;
          height: 40px;
          // position: absolute;
          // top: 46px;
          // left: 32px;
          z-index: -1;
        }
      }
      .isSelect-item{
        span{
          color: #FF9600;
        }
        
      }
    }
  }
}
</style>
